/**
 * Extracts initials from a user's full name
 * @param name - The user's full name
 * @returns The first letter of each word, up to 2 characters
 */
export const getInitials = (name: string): string => {
  if (!name || name.trim() === '') return 'U'
  
  return name
    .trim()
    .split(' ')
    .filter(word => word.length > 0) // Remove empty strings
    .map(word => word.charAt(0).toUpperCase())
    .join('')
    .slice(0, 2) // Limit to 2 characters
}
